/* « Diagnostic : formulaire » : postcode → email → n8n webhook → link to /apps/water-report?token=…
   Postcodes checked by format only (one request). ?wr_market=FR|DE|UK|US|AUS: QA. */
(function () {
  'use strict';

  var SOURCE = 'water-lookup'; // must stay in n8n's "If - Popup ?" allow-list
  var PATTERNS = {
    UK: /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i,
    US: /^\d{5}(-\d{4})?$/,
    FR: /^\d{5}$/,
    DE: /^\d{5}$/,
    AUS: /^\d{4}$/
  };
  var MAX_LENGTH = { UK: 8, US: 10, FR: 5, DE: 5, AUS: 4 };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 3 | 8)).toString(16);
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function push(event, market) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: event, market: market }); } catch (e) {}
  }

  function init(root) {
    var CONFIG = window.WaterReportConfig || {};
    var i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-wrd-i18n]').textContent); } catch (e) {}
    var $ = function (s) { return root.querySelector(s); };
    var card = $('[data-wrd-form]');
    var pcForm = $('[data-wrd-step="postcode"]');
    var emailForm = $('[data-wrd-step="email"]');
    var pcInput = $('[data-wrd-pc]');
    var pcWrap = $('[data-wrd-pcwrap]');
    var emailInput = $('[data-wrd-email]');
    var dots = root.querySelectorAll('[data-wrd-dot]');
    var market = root.getAttribute('data-market') || 'UK';
    var zipcode = '';

    var params = new URLSearchParams(location.search);
    var forced = (params.get('wr_market') || '').toUpperCase().replace(/^AU$/, 'AUS').replace(/^GB$/, 'UK');
    var mk = (i18n.markets || {})[forced];
    if (mk) {
      market = forced;
      document.querySelectorAll('[data-wd-only]').forEach(function (el) {
        el.hidden = el.getAttribute('data-wd-only') !== 'ok';
      });
      $('[data-wrd-pc-label]').textContent = mk.label;
      pcInput.placeholder = mk.ph;
    }
    mk = (i18n.markets || {})[market] || {};

    function setStep(step) {
      card.setAttribute('data-step', step);
      var two = step !== 'postcode';
      $('[data-wrd-stepnum]').textContent = two ? i18n.step2 : i18n.step1;
      dots[1].toggleAttribute('data-on', two);
    }

    function showError(form, msg) {
      form.querySelector('[data-wrd-error]').textContent = msg || '';
    }

    function pcOk(v) { return PATTERNS[market].test(v.trim()); }

    function onPcInput() {
      showError(pcForm, '');
      pcInput.removeAttribute('aria-invalid');
      if (pcOk(pcInput.value)) pcWrap.setAttribute('data-state', 'valid');
      else pcWrap.removeAttribute('data-state');
    }

    pcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = pcInput.value.trim().toUpperCase();
      if (!pcOk(v)) {
        pcWrap.setAttribute('data-state', 'invalid');
        pcInput.setAttribute('aria-invalid', 'true');
        showError(pcForm, mk.err);
        pcInput.focus();
        return;
      }
      zipcode = v;
      $('[data-wrd-pc-echo]').textContent = v;
      setStep('email');
      setTimeout(function () { emailInput.focus(); }, 60);
      push('water_diagnostic_postcode', market);
    });

    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (card.getAttribute('data-step') === 'sending') return;
      var email = emailInput.value.trim();
      if (!EMAIL_RE.test(email)) {
        emailInput.setAttribute('aria-invalid', 'true');
        showError(emailForm, i18n.emailErr);
        emailInput.focus();
        return;
      }
      if (!CONFIG.webhookUrl) return showError(emailForm, i18n.netErr);
      setStep('sending');
      showError(emailForm, '');

      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 30000);
      fetch((market === 'US' && CONFIG.webhookUrlUS) || CONFIG.webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, phone: '', zipcode: zipcode, popup_session_id: uuid(), source: SOURCE, market: market }),
        signal: ctrl.signal
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Webhook ' + r.status);
          return r.json();
        })
        .then(function (res) {
          var token = res && (res.token || res.report_token);
          if (!token) throw new Error('No token');
          $('[data-wrd-done-text]').innerHTML = esc(i18n.doneText || '')
            .replace('__POSTCODE__', '<b>' + esc(zipcode) + '</b>')
            .replace('__EMAIL__', '<b>' + esc(email) + '</b>');
          $('[data-wrd-report]').href = (CONFIG.redirectUrl || '/apps/water-report') + '?token=' + encodeURIComponent(token);
          setStep('done');
          $('[data-wrd-step="done"]').focus({ preventScroll: true });
          push('water_diagnostic_submit', market);
        })
        .catch(function () {
          setStep('email');
          showError(emailForm, i18n.reportErr || i18n.netErr);
        })
        .then(function () { clearTimeout(timer); });
    });

    pcInput.addEventListener('input', onPcInput);
    emailInput.addEventListener('input', function () {
      emailInput.removeAttribute('aria-invalid');
      showError(emailForm, '');
    });
    $('[data-wrd-back]').addEventListener('click', function () {
      setStep('postcode');
      pcInput.focus();
    });
    $('[data-wrd-again]').addEventListener('click', function () {
      pcInput.value = '';
      onPcInput();
      setStep('postcode');
      pcInput.focus();
    });

    // Links to the form from other sections: scroll, then focus the field.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('a[href="#water-diag-form"]')) return;
      e.preventDefault();
      card.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      var step = card.getAttribute('data-step');
      if (step !== 'done') (step === 'postcode' ? pcInput : emailInput).focus({ preventScroll: true });
    });

    pcInput.maxLength = MAX_LENGTH[market];
    pcInput.inputMode = market === 'UK' ? 'text' : 'numeric';
    setStep('postcode');

    var pre = (params.get('postcode') || '').trim().slice(0, 10);
    if (pre) {
      pcInput.value = pre;
      onPcInput();
      card.scrollIntoView({ block: 'center' });
      pcInput.focus({ preventScroll: true });
    }
  }

  // Loaded with defer: the DOM is ready.
  document.querySelectorAll('[data-wrd]').forEach(init);
})();
